<template>
  <v-dialog v-model="dialog" @click:outside="$emit('updateDialog')" width="750">
    <v-card>
      <v-card-title>
        <span class="headline">Item de Formula</span>
      </v-card-title>

      <v-card-text>
        <v-text-field 
          autocomplete="off" 
          name="orden_secuencia" 
          label="Orden de Secuencia*" 
          type="number" 
          v-model="item.orden_secuencia" 
          v-validate="'required|numeric'" 
        />
        <span class="red--text">{{ errors.first("orden_secuencia") }}</span>

        <v-combobox
          v-model="item.type"
          data-vv-as="Tipo"
          name="type"
          :items="types"
          item-text="name"
          item-value="id"
          label="Tipo*"
          v-validate="'required'"
          @change="onTypeChange"
        ></v-combobox>
        <span class="red--text">{{ errors.first("type") }}</span>

        <!-- Mostrar según el tipo -->
        <div v-if="item.type.id === 'R'">
          <v-combobox
            v-model="item.resource"
            data-vv-as="Recurso"
            name="resource"
            item-text="label"
            item-value="id"
            :items="resources"
            label="Recurso*"
            autocomplete="off"
            v-validate="item.type.id === 'R' ? 'required|combobox_required' : ''"
          ></v-combobox>
          <span class="red--text">{{ errors.first("resource") }}</span>
        </div>

        <div v-if="item.type.id === 'M'">
          <v-combobox
            v-model="item.raw_material"
            data-vv-as="Materia Prima"
            name="raw_material"
            item-text="label"
            item-value="id"
            :items="raw_materials"
            label="Materia Prima*"
            autocomplete="off"
            v-validate="item.type.id === 'M' ? 'required|combobox_required' : ''"
          ></v-combobox>
          <span class="red--text">{{ errors.first("raw_material") }}</span>
        </div>

        <!-- <div v-if="item.type.id === 'S'">
          <v-combobox
            v-model="item.formula_semi"
            data-vv-as="Formula Semi-elaborada"
            name="formula_semi"
            item-text="name"
            item-value="id"
            :items="formulas"
            label="Formula Semi-elaborada*"
            autocomplete="off"
            v-validate="item.type.id === 'S' ? 'required|combobox_required' : ''"
          ></v-combobox>
          <span class="red--text">{{ errors.first("formula_semi") }}</span>
        </div> -->

        <div v-if="item.type.id === 'P'">
          <v-combobox
            v-model="item.product"
            data-vv-as="Producto"
            name="product"
            item-text="label"
            item-value="id"
            :items="products"
            label="Producto*"
            autocomplete="off"
            v-validate="item.type.id === 'P' ? 'required|combobox_required' : ''"
          ></v-combobox>
          <span class="red--text">{{ errors.first("product") }}</span>
        </div>

          <v-text-field 
          autocomplete="off" 
          name="valor" 
          label="Cantidad*" 
          type="number" 
          v-model="item.valor" 
          v-validate="'required|decimal'" 
        />
        <span class="red--text">{{ errors.first("valor") }}</span>

        <v-textarea
          autocomplete="off"
          name="observacion"
          label="Observación"
          v-model="item.observacion"
          rows="3"
        ></v-textarea>

      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="close"> Cerrar </v-btn>
        <v-btn color="success" text @click="save"> Agregar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { generalService } from "@/libs/ws/generalService";
import { formulaService } from "@/libs/ws/formulaService";
import ConstantSections from "@/constants/sections";
import { FORMULA_ITEM_TYPE_CONFIG as TYPE_CONFIG } from "@/constants/formulaItemTypes";

export default {
  props: {
    dialog: Boolean,
    itemEdit: Object,
    formula: Object,
  },
  data: () => ({
    item: {
      id: "",
      type: "",
      orden_secuencia: 1,
      valor: 0,
      observacion: "",
      resource: null,
      raw_material: null,
      formula_semi: null,
      product: null,
    },
    defaultItem: null,
    types: [],
    resources: [],
    raw_materials: [],
    formulas: [],
    products: [],
  }),
  watch: {
    dialog(val) {
      if (val) {
        this.errors.clear();
        if (this.itemEdit != null) {
          this.item = Object.assign({}, this.itemEdit);
        } else {
          this.item = Object.assign({}, this.defaultItem);
          // Auto-calcular el siguiente orden
          if (this.formula.items && this.formula.items.length > 0) {
            const maxOrden = Math.max(...this.formula.items.map(i => i.orden_secuencia || 0));
            this.item.orden_secuencia = maxOrden + 1;
          } else {
            this.item.orden_secuencia = 1;
          }
        }
      }
    },
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
    this.loadTypesFormulasItems();
    this.loadResources();
    this.loadRawMaterials();
    this.loadFormulas();
    this.loadProducts();
  },
  methods: {
    loadTypesFormulasItems() {
     formulaService
        .list_types_formula_items()
        .then((response) => {
          this.types = response.result;  
        })
        .catch((e) => {
          console.log("types.list error");
          console.log(e);
        });
    },
    onTypeChange() {
      // Limpiar todas las referencias excepto la del tipo seleccionado
      const selectedTypeId = this.item.type?.id;
      Object.keys(TYPE_CONFIG).forEach(typeId => {
        if (typeId !== selectedTypeId) {
          const config = TYPE_CONFIG[typeId];
          this.item[config.entityKey] = null;
          this.errors.remove(config.entityKey);
        }
      });
    },
    loadResources() {
      generalService.setSection(ConstantSections.SECTION_RESOURCES);
      generalService
        .filter()
        .then((response) => {
          this.resources = response.result;
        })
        .catch((e) => {
          console.log("resources.filter error");
          console.log(e);
        });
    },
    loadRawMaterials() {
      generalService.setSection(ConstantSections.SECTION_RAW_MATERIALS);
      generalService
        .filter()
        .then((response) => {
          this.raw_materials = response.result;
        })
        .catch((e) => {
          console.log("raw_materials.filter error");
          console.log(e);
        });
    },
    loadFormulas() {
      formulaService
        .filter_semi_elaboradas()
        .then((response) => {
          this.formulas = response.result;
        })
        .catch((e) => {
          console.log("formulas.filter_semi_elaboradas error");
          console.log(e);
        });
    },
    loadProducts() {
      const params = {};
      generalService.setSection(ConstantSections.SECTION_PRODUCTS);
      generalService
        .query(params, ConstantSections.SECTION_PRODUCTS + "/presentations")
        .then((response) => {
          this.products = response.result;
        })
        .catch((e) => {
          console.error("Error loading presentations:", e);
        });
    },
    save() {
      console.log("item to save", this.item);
      

      this.$validator.validate().then((valid) => {
        console.log("validation result", valid);
        if (valid) {
          console.log("if valid", valid)
          this.$emit("addItem", Object.assign({}, this.item));
          this.close();
        }
      });
    },
    close() {
      this.$emit("updateDialog", false);
      this.item = Object.assign({}, this.defaultItem);
    },
  },
};
</script>
